<div class="weekly-report">
  <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
  <div class="weekly-report-header">
    <button class="btn btn-close-weekly-report" (click)="onClose()">
      <span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'xmark']" [fixedWidth]="true"></fa-icon
      ></span>
    </button>
    <h1>Week {{ weekNo }} Report</h1>
  </div>
  <div class="weekly-report-body">
    <nav class="weekly-report-nav">
      <div class="weekly-report-nav-shadow"></div>
      <ul>
        <li
          [ngClass]="{ active: pageId == 'prepSteps' }"
          *ngIf="pages.indexOf('prepSteps') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Prep Steps"
            (click)="goToPage('prepSteps')"
            aria-label="Prep Steps"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['fas', 'walking']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'prepFit' }"
          *ngIf="pages.indexOf('prepFit') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Prep Fit"
            (click)="goToPage('prepFit')"
            aria-label="Prep Fit"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['fas', 'running']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'prepStrong' }"
          *ngIf="pages.indexOf('prepStrong') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Prep Strong"
            (click)="goToPage('prepStrong')"
            aria-label="Prep Strong"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="$any(['fac', 'lunge'])"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'breatheWell' }"
          *ngIf="pages.indexOf('breatheWell') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Breathe Well"
            (click)="goToPage('breatheWell')"
          >
            <span class="icon-wrap"
              ><fa-icon [icon]="['fas', 'lungs']" [fixedWidth]="true"></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'eatWell' }"
          *ngIf="pages.indexOf('eatWell') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Eat Well"
            (click)="goToPage('eatWell')"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['fas', 'cutlery']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'drinkingGuide' }"
          *ngIf="pages.indexOf('drinkingGuide') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Drinking Guide"
            (click)="goToPage('drinkingGuide')"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['fas', 'martini-glass']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'iQuit' }"
          *ngIf="pages.indexOf('iQuit') !== -1"
        >
          <button
            class="btn w-100"
            title="I-Quit"
            (click)="goToPage('iQuit')"
            type="button"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['far', 'smoking-ban']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'sleepWell' }"
          *ngIf="pages.indexOf('sleepWell') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Sleep Well"
            (click)="goToPage('sleepWell')"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['far', 'face-sleeping']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
        <li
          [ngClass]="{ active: pageId == 'feelWell' }"
          *ngIf="pages.indexOf('feelWell') !== -1"
        >
          <button
            type="button"
            class="btn w-100"
            title="Feel Well"
            (click)="goToPage('feelWell')"
          >
            <span class="icon-wrap"
              ><fa-icon
                [icon]="['far', 'face-smile-relaxed']"
                [fixedWidth]="true"
              ></fa-icon
            ></span>
          </button>
        </li>
      </ul>
    </nav>

    <ng-container *ngIf="weekNo">
      <nav class="weekly-report-page-nav">
        <button
          class="btn"
          title="Previous page"
          [disabled]="page == 1"
          (click)="onPrevPage()"
        >
          <span class="icon-wrap"
            ><fa-icon
              [icon]="['fas', 'chevron-circle-left']"
              [fixedWidth]="true"
            ></fa-icon
          ></span>
        </button>
        <div>Page {{ page }} of {{ pages.length }}</div>
        <button
          class="btn text-end"
          title="Next page"
          [disabled]="page == pages.length"
          (click)="onNextPage()"
        >
          <span class="icon-wrap"
            ><fa-icon
              [icon]="['fas', 'chevron-circle-right']"
              [fixedWidth]="true"
            ></fa-icon
          ></span>
        </button>
      </nav>

      <!-- Prep Steps -->
      <div class="weekly-report-page" *ngIf="pageId == 'prepSteps'">
        <h2 class="weekly-report-page-title">
          <span class="icon-wrap"
            ><fa-icon [icon]="['fas', 'walking']" [fixedWidth]="true"></fa-icon
          ></span>
          Prep Steps
        </h2>

        <div class="weekly-report-text mt-2 mb-3" *ngIf="+weekStepTotal > 0">
          <p>
            Well done for recording your Prep Step count this week. This all
            counts towards increasing your physical activity and getting your
            cardiovascular system ready for surgery.
          </p>

          <ng-container *ngIf="stepDaysHit >= 7">
            <p>
              Amazing! Well done for hitting your daily step count every day
              this week!
            </p>
            <p>
              Keep it up and maybe even increase your daily step count for next
              week!
            </p>
            <p>
              You may also want consider increasing your
              <a [routerLink]="['/activity', 'steps', 'target']"
                >daily steps target</a
              >.
            </p>
          </ng-container>

          <ng-container
            *ngIf="stepDaysHit < 7 && stepDaysHit > stepDaysHitLastWeek"
          >
            <p>
              Great! Well done for hitting your daily step count on
              {{ stepDaysHit }} days. This is more days than last week/previous
              weeks.
            </p>
            <p>
              Keep going and even try hitting your daily step count on more days
              over next week.
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              stepDaysHit < 7 &&
              stepDaysHit == stepDaysHitLastWeek &&
              stepDaysHit > 0
            "
          >
            <p>
              Great! Well done for hitting your daily step count on
              {{ stepDaysHit }} days. This is about the same amount as last
              week.
            </p>
            <p>
              Why not increase your daily step count for next week by checking
              out our top tips for keeping active.
            </p>
          </ng-container>

          <ng-container
            *ngIf="stepDaysHit < 7 && stepDaysHit < stepDaysHitLastWeek"
          >
            <p>
              This week you hit your daily step count on {{ stepDaysHit }} days.
              This is a little less than last week/previous weeks.
            </p>
            <p>
              To increase your daily step count for next week, this is probably
              a good time to check out our top tips for keeping active, which
              can help you increase your daily step count."
            </p>
          </ng-container>
        </div>
        <div *ngIf="+weekStepTotal == 0" class="weekly-report-text mt-2 mb-3">
          <p>
            You didn't record any steps this week. Don't worry and try to record
            them next week.
          </p>
        </div>
        <h3 class="text-center">Weekly Performance</h3>

        <div class="weekly-report-stats mb-4">
          <div class="weekly-report-stat">
            <div class="weekly-report-stat-title">Days Target Hit</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                stepDaysHit
              }}</span>
              <span
                class="weekly-report-stat-info-change"
                *ngIf="stepDaysHit - stepDaysHitLastWeek != 0"
              >
                <ng-container *ngIf="stepDaysHit - stepDaysHitLastWeek > 0">
                  <span class="icon-wrap duo-primary-dark"
                    ><fa-icon
                      [icon]="['fad', 'caret-circle-up']"
                      [fixedWidth]="true"
                    ></fa-icon
                  ></span>
                  <span>+{{ stepDaysHit - stepDaysHitLastWeek }}</span>
                </ng-container>

                <ng-container *ngIf="stepDaysHit - stepDaysHitLastWeek < 0">
                  <span class="icon-wrap duo-danger-white"
                    ><fa-icon
                      [icon]="['fad', 'caret-circle-down']"
                      [fixedWidth]="true"
                    ></fa-icon
                  ></span>
                  <span>{{ stepDaysHit - stepDaysHitLastWeek }}</span>
                </ng-container>
              </span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week: <strong>{{ stepDaysHitFirstWeek }}</strong></span
              >
              <span
                >Previous Week: <strong>{{ stepDaysHitLastWeek }}</strong></span
              >
            </div>
          </div>

          <!--div class="weekly-report-stat">
            <div class="weekly-report-stat-title">Steps this Week</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                weekStepTotal | number
              }}</span>
              <span class="weekly-report-stat-info-change" *ngIf="+weekNo > 1">
                <span class="icon-wrap duo-primary-dark"
                  ><fa-icon
                    *ngIf="weekStepTotal - prevWeekStepTotal > 0"
                    [icon]="['fad', 'caret-circle-up']"
                    [fixedWidth]="true"
                  ></fa-icon>
                  <fa-icon
                    *ngIf="weekStepTotal - prevWeekStepTotal < 0"
                    [icon]="['fad', 'caret-circle-down']"
                    [fixedWidth]="true"
                  ></fa-icon>
                </span>
                <span>{{ weekStepTotal - prevWeekStepTotal | number }}</span>
              </span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong>{{ firstWeekStepTotal | number }}</strong></span
              >
              <span  *ngIf="+weekNo > 1"
                >Previous Week:
                <strong>{{ prevWeekStepTotal | number }}</strong></span
              >
            </div>
          </div-->
        </div>
        <h3 class="text-center">Trend Graph</h3>
        <app-weekly-report-chart-steps
          *ngIf="allWeeksStepData.length > 0"
          [weeksData]="allWeeksStepData"
        ></app-weekly-report-chart-steps>
      </div>

      <!-- Prep Fit -->
      <div class="weekly-report-page" *ngIf="pageId == 'prepFit'">
        <h2 class="weekly-report-page-title">
          <span class="icon-wrap"
            ><fa-icon [icon]="['fas', 'running']" [fixedWidth]="true"></fa-icon
          ></span>
          Prep Fit
        </h2>

        <div class="weekly-report-text mt-2 mb-3" *ngIf="+cardioMinsWeek > 0">
          <p>
            Well done for recording your Prep Fit activity this week. This all
            counts towards increasing your fitness and supporting your
            cardiovascular system in preparation for surgery.
          </p>

          <ng-container *ngIf="cardioWeekProgressed">
            <p>
              Excellent! Well done for sticking with Prep Fit and progressing to
              next level. You are getting fitter and better prepared for surgery
            </p>
          </ng-container>

          <ng-container *ngIf="cardioWeekHit">
            <p>
              Great! Well done for hitting your Prep Fit level target this week.
            </p>
            <p>Keep it up for next week. You're getting fitter for surgery!</p>
            <p>
              Also, you may now be ready to move to the next Prep Fit Level.
            </p>
          </ng-container>

          <ng-container
            *ngIf="!cardioWeekHit && cardioMinsWeek > cardioMinsLastWeek"
          >
            <!-- and more than last week -->
            <p>
              Great effort working toward the target for this stage of Prep Fit!
              See if you can get even closer next week?
            </p>
          </ng-container>

          <ng-container
            *ngIf="!cardioWeekHit && cardioMinsWeek == cardioMinsLastWeek"
          >
            <!-- and same as last week -->
            <p>
              This week your number of Prep Fit minutes decreased. We know it
              isn't always easy to fit exercise in before your operation.
            </p>
            <p>
              This may be a good time to revisit our top tips for Prep Fit and
              increasing your fitness for surgery. You can also speak with the
              iPREPWELL team.
            </p>
          </ng-container>

          <ng-container
            *ngIf="!cardioWeekHit && cardioMinsWeek < cardioMinsLastWeek"
          >
            <!-- and less than last week -->
            <p>
              Great effort working toward the target for this stage of Prep Fit!
              See if you can get even closer next week?
            </p>
          </ng-container>
        </div>
        <div *ngIf="+cardioMinsWeek == 0" class="weekly-report-text mt-2 mb-3">
          <p>
            You didn't record any minutes this week. Don't worry and try to
            record them next week.
          </p>
        </div>
        <h3 class="text-center">Weekly Performance</h3>

        <div class="weekly-report-stats mb-4">
          <div class="weekly-report-stat">
            <div class="weekly-report-stat-title">Total Minutes This Week</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                cardioMinsWeek
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week: <strong>{{ cardioMinsFirstWeek }}</strong></span
              >
              <span
                >Previous Week: <strong>{{ cardioMinsLastWeek }}</strong></span
              >
            </div>
          </div>
        </div>
        <h3 class="text-center">Trend Graph</h3>

        <app-weekly-report-chart-fit
          *ngIf="allWeeksCardioData.length > 0"
          [weeksData]="allWeeksCardioData"
        ></app-weekly-report-chart-fit>
      </div>

      <!-- Prep Strong -->
      <div class="weekly-report-page" *ngIf="pageId == 'prepStrong'">
        <h2 class="weekly-report-page-title">
          <span class="icon-wrap"
            ><fa-icon
              [icon]="$any(['fac', 'lunge'])"
              [fixedWidth]="true"
            ></fa-icon
          ></span>
          Prep Strong
        </h2>

        <div class="weekly-report-text mt-2 mb-3" *ngIf="+moveWeekWorkouts > 0">
          <p>
            Well done for recording your Prep Strong session/s this week. This
            all counts towards increasing your strength and building your muscle
            in preparation for surgery.
          </p>

          <ng-container *ngIf="moveWeekProgressed">
            <p>
              Excellent! Well done for sticking with Prep Strong and progressing
              to next level. You are getting stronger and better prepared for
              surgery
            </p>
          </ng-container>

          <ng-container *ngIf="moveWeekWorkouts >= 2">
            <p>
              Great! Well done for hitting your weekly target of two Prep Strong
              sessions this week.
            </p>
            <p>Keep it up for next week. You're getting stronger for surgery</p>
          </ng-container>

          <ng-container *ngIf="moveWeekWorkouts == 1">
            <!-- and more than last week -->
            <p>
              Well done for logging a Prep Strong session this week - this will
              help you get stronger for surgery.
            </p>
            <p>
              Why not try two Prep Strong sessions next week to get even better
              prepared for your operation?
            </p>
          </ng-container>
        </div>
        <div
          *ngIf="+moveWeekWorkouts == 0"
          class="weekly-report-text mt-2 mb-3"
        >
          <p>
            You didn't record any workouts this week. Don't worry and try to
            record them next week.
          </p>
        </div>
        <h3 class="text-center">Weekly Performance</h3>

        <div class="weekly-report-stats mb-4">
          <div class="weekly-report-stat">
            <div class="weekly-report-stat-title">Total Sessions This Week</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                moveWeekWorkouts
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week: <strong>{{ moveFirstWeekWorkouts }}</strong></span
              >
              <span
                >Previous Week:
                <strong>{{ moveLastWeekWorkouts }}</strong></span
              >
            </div>
          </div>
        </div>
        <h3 class="text-center">Trend Graph</h3>

        <app-weekly-report-chart-strong
          *ngIf="allWeeksMoveData.length > 0"
          [weeksData]="allWeeksMoveData"
        ></app-weekly-report-chart-strong>
      </div>

      <!-- Breathe Well -->
      <div class="weekly-report-page" *ngIf="pageId == 'breatheWell'">
        <h2 class="weekly-report-page-title">
          <span class="icon-wrap"
            ><fa-icon [icon]="['fas', 'lungs']" [fixedWidth]="true"></fa-icon
          ></span>
          Breathe Well
        </h2>

        <div class="weekly-report-text mt-2 mb-3" *ngIf="+breatheSessions > 0">
          <p>
            Well done for recording your Breathe Well activity this week. This
            all counts towards to strengthening your lungs and the muscles you
            use to breathe, to help you prepare for surgery.
          </p>

          <ng-container *ngIf="breathLevelChange > 0">
            <p>
              Excellent! Well done for increasing your IMT resistance level -
              this means that both your lungs and the supporting muscles you use
              to breathe - are getting stronger for surgery. Keep it up!
            </p>
          </ng-container>

          <ng-container *ngIf="breatheSessions >= 14">
            <p>
              Wow! Well done for meeting your Breathe Well target this week!
            </p>
            <p>
              This all helps your lungs and the supporting muscles you use to
              breathe to get stronger for surgery. Keep it up!
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              breatheSessions < 14 && breatheSessions > breatheSessionsLastWeek
            "
          >
            <p>
              Well done for recording {{ breatheSessions }} Breathe Well
              sessions this week. You completed more Breathe Well sessions this
              week than last week/previous weeks.
            </p>
            <p>Keep it up and maybe try completing more sessions next week.</p>
          </ng-container>

          <ng-container
            *ngIf="
              breatheSessions < 14 && breatheSessions == breatheSessionsLastWeek
            "
          >
            <p>
              Well done for recording {{ breatheSessions }} Breathe Well
              sessions this week. This is the same amount of sessions you
              completed last week/previous weeks.
            </p>
            <p>
              Why not try increasing your Breathe Well sessions, even by just a
              little, over next week?
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              breatheSessions < 14 && breatheSessions < breatheSessionsLastWeek
            "
          >
            <p>
              This week your number of Breathe Well sessions decreased this
              week.
            </p>
            <p>
              This may be a good time to revisit our top tips for Breathe Well
              and increasing your fitness for surgery. You can also speak with
              the iPREPWELL team for further support.
            </p>
          </ng-container>
        </div>
        <div *ngIf="+breatheSessions == 0" class="weekly-report-text mt-2 mb-3">
          <p>
            You didn't record any workouts this week. Don't worry and try to
            record them next week.
          </p>
        </div>
        <h3 class="text-center">Weekly Performance</h3>

        <div class="weekly-report-stats mb-4">
          <div class="weekly-report-stat">
            <div class="weekly-report-stat-title">Total Sessions This Week</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                breatheSessions
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week: <strong>{{ breatheSessionsFirstWeek }}</strong></span
              >
              <span
                >Previous Week:
                <strong>{{ breatheSessionsLastWeek }}</strong></span
              >
            </div>
          </div>
        </div>
        <h3 class="text-center">Trend Graph</h3>

        <app-weekly-report-chart-breathe
          *ngIf="allWeeksBreatheData.length > 0"
          [weeksData]="allWeeksBreatheData"
        ></app-weekly-report-chart-breathe>
      </div>

      <!-- Eat Well-->
      <div class="weekly-report-page" *ngIf="pageId == 'eatWell'">
        <h2 class="weekly-report-page-title">
          <span class="icon-wrap"
            ><fa-icon [icon]="['fas', 'cutlery']" [fixedWidth]="true"></fa-icon
          ></span>
          Eat Well
        </h2>

        <div
          class="weekly-report-text mt-2 mb-3"
          *ngIf="+eatWellTotals.daysEntered > 0"
        >
          <p>
            Well done for monitoring your healthy eating and hydration levels
            using Eat Well! This will help you keep on track with your
            nutrition, which supports your body to prepare surgery!
          </p>

          <ng-container *ngIf="+eatWellTotals.score >= 35">
            <p>
              Wow! Well done for hitting your healthy eating and hydration goals
              all week! This will really help you give your body the nourishment
              it needs to prepare for surgery.
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              eatWellDaysHit > 0 &&
              eatWellDaysHit < 7 &&
              eatWellDaysHit >= eatWellDaysHitLastWeek
            "
          >
            <p>
              This week you recorded meeting your healthy eating and hydration
              goals on {{ eatWellDaysHit }} days. This is an increase
              from/roughly the same healthy eating and hydration progress you
              made from last week/previous weeks. This is great work! Keep it up
              and try to make more days a 'healthy eating and staying hydrated
              day'
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              eatWellDaysHit > 0 &&
              eatWellDaysHit < 7 &&
              eatWellDaysHit < eatWellDaysHitLastWeek
            "
          >
            <p>
              This week you recorded meeting your healthy eating and hydration
              goals on {{ eatWellDaysHit }} days. This is a bit less than the
              healthy eating and hydration progress you made from last
              week/previous weeks.
            </p>
            <p>
              Why not try revisiting our top tips for eating well while
              preparing for surgery?
            </p>
          </ng-container>

          <ng-container *ngIf="eatWellDaysHit == 0">
            <p>This week you recorded no healthy eating and hydration days.</p>

            <p>
              Recording and monitoring your Eat Well progress is a great way to
              track whether you are getting the right amount and type of
              nutrients to help your body prepare for surgery. This might be a
              good time to check out our top tips or to speak with the iPREPWELL
              team for more support.
            </p>
          </ng-container>

          <!-- protein -->
          <ng-container *ngIf="eatWellStatsLastWeek">
            <ng-container *ngIf="+eatWellStats.daysHit.protein == 7">
              <p>
                Wow! Excellent! Protein is so important to help build and
                support your muscle, which you will need to help you prepare for
                surgery and recover afterwards. Keep it up
              </p>
            </ng-container>

            <ng-container
              *ngIf="
                eatWellStats.daysHit.protein > 0 &&
                eatWellStats.daysHit.protein < 7 &&
                eatWellStats.daysHit.protein >=
                  eatWellStatsLastWeek.daysHit.protein
              "
            >
              <p>
                This week you met your daily protein goal on
                {{ +eatWellStats.daysHit.protein }} days. And this is an
                increase from/the same as last week/previous weeks. This is
                great – protein is so important to support your body and build
                your muscle for surgery. Keep it up!
              </p>
            </ng-container>

            <ng-container
              *ngIf="
                eatWellStats.daysHit.protein > 0 &&
                eatWellStats.daysHit.protein < 7 &&
                eatWellStats.daysHit.protein <
                  eatWellStatsLastWeek.daysHit.protein
              "
            >
              <p>
                This week you met your daily protein goal on
                {{ +eatWellStats.daysHit.protein }} days. This is a bit less
                than last week but keep going! Your body uses protein to build
                and support your muscles, which you need to prepare your body
                for surgery, and to support your recovery after surgery.
              </p>

              <p>
                We have lots of top tips to help you stay focussed on meeting
                you healthy eating and hydration goals take a look or revisit
                the module for help.
              </p>
            </ng-container>

            <ng-container *ngIf="eatWellStats.daysHit.protein == 0">
              <p>This week you recorded no protein intake.</p>

              <p>
                Recording and monitoring your Eat Well progress is a great way
                to track whether you are getting enough protein to help you
                prepare for surgery. This might be a good time to check out our
                top tips or to speak with the iPREPWELL team for more support.
              </p>
            </ng-container>
          </ng-container>
        </div>
        <div
          *ngIf="+eatWellTotals.daysEntered == 0"
          class="weekly-report-text mt-2 mb-3"
        >
          <p>
            You didn't record any eat well data this week. Don't worry and try
            to record it next week.
          </p>
        </div>
        <h3 class="text-center">Weekly Performance</h3>

        <div class="weekly-report-stats mb-4">
          <div class="weekly-report-stat">
            <div class="weekly-report-stat-title">Days Hit This Week</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                eatWellDaysHit
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week: <strong>{{ eatWellDaysHitFirstWeek }}</strong></span
              >
              <span
                >Previous Week:
                <strong>{{ eatWellDaysHitLastWeek }}</strong></span
              >
            </div>
          </div>

          <div class="weekly-report-stat" *ngIf="eatWellStatsLastWeek">
            <div class="weekly-report-stat-title">
              Days Hit Protein This Week
            </div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                eatWellStats.daysHit.protein
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong>{{
                  eatWellStatsFirstWeek.daysHit.protein
                }}</strong></span
              >
              <span
                >Previous Week:
                <strong>{{
                  eatWellStatsLastWeek.daysHit.protein
                }}</strong></span
              >
            </div>
          </div>

          <div class="weekly-report-stat" *ngIf="eatWellTotalsLastWeek">
            <div class="weekly-report-stat-title">Score This Week</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                eatWellTotals.weekScore
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong>{{ eatWellTotalsFirstWeek.weekScore }}</strong></span
              >
              <span
                >Previous Week:
                <strong>{{ eatWellTotalsLastWeek.weekScore }}</strong></span
              >
            </div>
          </div>
        </div>
        <h3 class="text-center">Trend Graph</h3>

        <app-weekly-report-chart-eat-well
          *ngIf="allWeeksEatWellData.length > 0"
          [weeksData]="allWeeksEatWellData"
        ></app-weekly-report-chart-eat-well>
      </div>

      <!-- Drinking Guide-->
      <div class="weekly-report-page" *ngIf="pageId == 'drinkingGuide'">
        <h2 class="weekly-report-page-title">
          <span class="icon-wrap"
            ><fa-icon
              [icon]="['fas', 'martini-glass']"
              [fixedWidth]="true"
            ></fa-icon
          ></span>
          Drinking guide
        </h2>

        <div
          class="weekly-report-text mt-2 mb-3"
          *ngIf="+drinkTotals.daysEntered > 0"
        >
          <p>
            Well done for monitoring your alcohol intake using Drink Guide! This
            will help keep your intake on track in the lead up to surgery!
          </p>
          <ng-container *ngIf="+drinkTotals.totalUnits <= 14">
            <p>
              This week you have kept within 14 units of alcohol. This is great
              news! Let's see if next week, you can keep it there all the way up
              to your operation!
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              +drinkTotals.totalUnits > 14 &&
              drinkTotals.totalUnits < drinkTotalsLastWeek.totalUnits
            "
          >
            <p>
              This week you recorded drinking more than 14 units of alcohol.
              Although this is more than your target for surgery, this is still
              less units than last week/previous weeks so well done! Keep this
              up and remember to try out some of our top tips and steps to help
              you keep your alcohol intake below 14 units before surgery.
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              +drinkTotals.totalUnits > 14 &&
              drinkTotals.totalUnits >= drinkTotalsLastWeek.totalUnits
            "
          >
            <p>
              This week you recorded drinking more than 14 units of alcohol.
            </p>

            <p>This is the same as/more than last week.</p>

            <p>
              This might be a good time to revisit our top tips and steps for
              reducing your alcohol intake to no more than 14 units per week. If
              you need more help, remember to speak to the iPREPWELL team.
            </p>
          </ng-container>

          <ng-container *ngIf="+drinkTotals.drinkFreeDays > 0">
            <p>
              Well done for recording a/some drink free day/s. Drink free days
              will help you to Sleep well, Eat well, Move well and Feel well for
              surgery
            </p>
            <p>
              Keep this going and why not try including more drink free days
              next week?
            </p>
          </ng-container>
          <ng-container
            *ngIf="
              +drinkTotals.drinkFreeDays > +drinkTotalsLastWeek.drinkFreeDays
            "
          >
            <p>
              Your drink free days have increased from last/are increasing -
              this is great news! Drink free days all help you to Sleep well,
              Eat well, Move well and Feel well for surgery
            </p>
            <p>
              Keep this going and why not try including even more drink free
              days next week?
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              +drinkTotals.drinkFreeDays == 0 && +drinkTotals.daysEntered > 0
            "
          >
            <p>
              This week, you recorded no drink free days. Try to include some
              drink free days each week and increase this over time to help you
              reduce your alcohol intake for surgery.
            </p>
            <p>
              You may find some of our top tips and steps useful or to speak
              with a healthcare professional for further support.
            </p>
          </ng-container>
        </div>
        <div
          *ngIf="+drinkTotals.daysEntered == 0"
          class="weekly-report-text mt-2 mb-3"
        >
          <p>
            You didn't record any drinking guide data this week. Don't worry and
            try to record it next week.
          </p>
        </div>
        <h3 class="text-center">Weekly Performance</h3>

        <div class="weekly-report-stats mb-4">
          <div class="weekly-report-stat">
            <div class="weekly-report-stat-title">Units Consumed</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                drinkTotals.totalUnits
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong>{{ drinkTotalsFirstWeek.totalUnits }}</strong></span
              >
              <span
                >Previous Week:
                <strong>{{ drinkTotalsLastWeek.totalUnits }}</strong></span
              >
            </div>
          </div>

          <div class="weekly-report-stats mb-4">
            <div class="weekly-report-stat">
              <div class="weekly-report-stat-title">Alcohol Free Days</div>
              <div class="weekly-report-stat-info">
                <span class="weekly-report-stat-info-value">{{
                  drinkTotals.drinkFreeDays
                }}</span>
              </div>
              <div class="weekly-report-stat-footer">
                <span
                  >1st Week:
                  <strong>{{
                    drinkTotalsFirstWeek.drinkFreeDays
                  }}</strong></span
                >
                <span
                  >Previous Week:
                  <strong>{{ drinkTotalsLastWeek.drinkFreeDays }}</strong></span
                >
              </div>
            </div>
          </div>
        </div>
        <h3 class="text-center">Trend Graph</h3>

        <app-weekly-report-chart-units
          *ngIf="allWeeksDrinkData.length > 0"
          [weeksData]="allWeeksDrinkData"
        ></app-weekly-report-chart-units>

        <app-weekly-report-chart-drink-free-days
          *ngIf="allWeeksDrinkData.length > 0"
          [weeksData]="allWeeksDrinkData"
        ></app-weekly-report-chart-drink-free-days>
      </div>

      <!-- I-Quit -->
      <div class="weekly-report-page" *ngIf="pageId == 'iQuit'">
        <h2 class="weekly-report-page-title">
          <span class="icon-wrap"
            ><fa-icon
              [icon]="['far', 'smoking-ban']"
              [fixedWidth]="true"
            ></fa-icon
          ></span>
          I-Quit
        </h2>

        <div
          class="weekly-report-text mt-2 mb-3"
          *ngIf="+smokingTotals.daysEntered > 0"
        >
          <p>
            Well done for monitoring your stopping smoking progress using
            i-Quit! This will help you keep on track with stopping smoking on
            the lead up to surgery!
          </p>
          <ng-container
            *ngIf="
              +smokingTotals.totalCigarettes > 0 &&
              +smokingTotals.totalCigarettes <
                +smokingTotalsLastWeek.totalCigarettes
            "
          >
            <p>
              This week you recorded smoking
              {{ smokingTotals.totalCigarettes }} cigarettes. Keep working
              towards your goal of stopping smoking for surgery - you're
              actually smoking less cigarettes than last week
            </p>

            <p>
              We know it isn't easy! Keep going! You can do it! Also, remember
              to check out our top tips for stopping smoking
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              +smokingTotals.totalCigarettes > 0 &&
              +smokingTotals.totalCigarettes >=
                +smokingTotalsLastWeek.totalCigarettes
            "
          >
            <p>
              This week you recorded smoking
              {{ smokingTotals.totalCigarettes }} cigarettes.
              <span
                *ngIf="
                  +smokingTotals.totalCigarettes ==
                  +smokingTotalsLastWeek.totalCigarettes
                "
                >This is the same amount of cigarettes as last week</span
              >
              <span
                *ngIf="
                  +smokingTotals.totalCigarettes >
                  +smokingTotalsLastWeek.totalCigarettes
                "
                >This is more cigarettes than last week</span
              >
              .
            </p>

            <p>
              This is probably a good time to revisit our tops tips for stopping
              smoking. You can also speak to the iPREPWELL team for further
              support. Working to stop smoking is one of the biggest steps you
              can take to reduce the risk of your operation.
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              +smokingTotals.smokeFreeDays >
              +smokingTotalsLastWeek.smokeFreeDays
            "
          >
            <p>
              Well done for recording some smoke free days. Smoke free days will
              help you to Move Well, Eat well, Feel well and Sleep well for
              surgery.
            </p>
            <p>
              Keep this going and why not try including more smoke free days
              next week
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              +smokingTotals.smokeFreeDays <=
              +smokingTotalsLastWeek.smokeFreeDays
            "
          >
            <p>
              Well done for recording some smoke free days. Smoke free days will
              help you to Move Well, Eat well, Feel well and Sleep well for
              surgery
            </p>
            <p>
              Keep this going to best prepare your surgery. Try including more
              smoke free days next, by trying out our stopping smoking top tips
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              +smokingTotals.smokeFreeDays == 0 &&
              +smokingTotalsLastWeek.daysEntered > 0
            "
          >
            <p>
              This week you recorded no smoke free days. Try to include some
              smoke free days each week and increase this over time to help you
              best prepare for surgery by stopping smoking.
            </p>
            <p>
              We know this isn’t easy! You may find some of our top tips and
              steps useful or to speak with the iPREPWELL team for further
              support.
            </p>
          </ng-container>
        </div>
        <div
          *ngIf="+drinkTotals.daysEntered == 0"
          class="weekly-report-text mt-2 mb-3"
        >
          <p>
            You didn't record any I-Quit data this week. Don't worry and try to
            record it next week.
          </p>
        </div>
        <h3 class="text-center">Weekly Performance</h3>

        <div class="weekly-report-stats mb-4">
          <div class="weekly-report-stat">
            <div class="weekly-report-stat-title">Cigarettes Smoked</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                smokingTotals.totalCigarettes
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong>{{
                  smokingTotalsFirstWeek.totalCigarettes
                }}</strong></span
              >
              <span
                >Previous Week:
                <strong>{{
                  smokingTotalsLastWeek.totalCigarettes
                }}</strong></span
              >
            </div>
          </div>

          <div class="weekly-report-stats mb-4">
            <div class="weekly-report-stat">
              <div class="weekly-report-stat-title">Smoke Free Days</div>
              <div class="weekly-report-stat-info">
                <span class="weekly-report-stat-info-value">{{
                  smokingTotals.smokeFreeDays
                }}</span>
              </div>
              <div class="weekly-report-stat-footer">
                <span
                  >1st Week:
                  <strong>{{
                    smokingTotalsFirstWeek.smokeFreeDays
                  }}</strong></span
                >
                <span
                  >Previous Week:
                  <strong>{{
                    smokingTotalsLastWeek.smokeFreeDays
                  }}</strong></span
                >
              </div>
            </div>
          </div>
        </div>
        <h3 class="text-center">Trend Graph</h3>

        <app-weekly-report-chart-cigarettes
          *ngIf="allWeeksSmokingData.length > 0"
          [weeksData]="allWeeksSmokingData"
        ></app-weekly-report-chart-cigarettes>

        <app-weekly-report-chart-smoke-free-days
          *ngIf="allWeeksSmokingData.length > 0"
          [weeksData]="allWeeksSmokingData"
        ></app-weekly-report-chart-smoke-free-days>
      </div>

      <!-- Sleep Well -->
      <div class="weekly-report-page" *ngIf="pageId == 'sleepWell'">
        <h2 class="weekly-report-page-title">
          <span class="icon-wrap"
            ><fa-icon
              [icon]="['fas', 'face-sleeping']"
              [fixedWidth]="true"
            ></fa-icon
          ></span>
          Sleep Well
        </h2>

        <div
          class="weekly-report-text mt-2 mb-3"
          *ngIf="+sleepTotal.totalDays > 0"
        >
          <p>
            Well done for recording your Sleep well progress! Sometimes we can
            forget just how important sleep is for our overall health and
            wellbeing. Prioritising your sleep will really help to prepare you
            for surgery and to Feel Well, Eat Well and get the most out of
            Moving Well too!
          </p>
          <p>
            We don't need our sleep to be perfect every night, we just need to
            feel good about sleep overall.
          </p>

          <p>
            Being mindful of how we are sleeping and how we feel about our sleep
            can help us identify patterns and make changes where needed.
          </p>

          <p>
            When looking at your weekly Sleep Well report, try to think about:
          </p>
          <ul>
            <li>How you feel about your sleep overall?</li>
            <li>
              Since starting the iPrepwell programme have you noticed any
              changes in your sleep?
            </li>
            <li>
              Is there anything you would like to change to improve your sleep?
            </li>
          </ul>
        </div>
        <div
          *ngIf="+sleepTotal.totalDays == 0"
          class="weekly-report-text mt-2 mb-3"
        >
          <p>
            You didn't record any Sleep Well data this week. Don't worry and try
            to record it next week.
          </p>
        </div>
        <h3 class="text-center">Weekly Performance</h3>

        <div class="weekly-report-stats mb-4">
          <div class="weekly-report-stat">
            <div class="weekly-report-stat-title">Overall Sleep Score</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                sleepTotal.average
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong>{{ sleepTotalFirstWeek.average }}</strong></span
              >
              <span
                >Previous Week:
                <strong>{{ sleepTotalLastWeek.average }}</strong></span
              >
            </div>
          </div>

          <div class="weekly-report-stat" *ngIf="sleepTotal.totalDays > 0">
            <div class="weekly-report-stat-title">Quality of Sleep</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                sleepTotal.quality / sleepTotal.totalDays
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong *ngIf="sleepTotalFirstWeek.totalDays > 0">{{
                  sleepTotalFirstWeek.quality / sleepTotalFirstWeek.totalDays
                }}</strong></span
              >
              <span
                >Previous Week:
                <strong *ngIf="sleepTotalLastWeek.totalDays > 0">{{
                  sleepTotalLastWeek.quality / sleepTotalLastWeek.totalDays
                }}</strong></span
              >
            </div>
          </div>

          <div class="weekly-report-stat" *ngIf="sleepTotal.totalDays > 0">
            <div class="weekly-report-stat-title">Getting to Sleep</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                sleepTotal.getting_sleep / sleepTotal.totalDays
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong *ngIf="sleepTotalFirstWeek.totalDays > 0">{{
                  sleepTotalFirstWeek.getting_sleep /
                    sleepTotalFirstWeek.totalDays
                }}</strong></span
              >
              <span
                >Previous Week:
                <strong *ngIf="sleepTotalLastWeek.totalDays > 0">{{
                  sleepTotalLastWeek.getting_sleep /
                    sleepTotalLastWeek.totalDays
                }}</strong></span
              >
            </div>
          </div>

          <div class="weekly-report-stat" *ngIf="sleepTotal.totalDays > 0">
            <div class="weekly-report-stat-title">Awakening from sleep</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                sleepTotal.awakening / sleepTotal.totalDays
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong *ngIf="sleepTotalFirstWeek.totalDays > 0">{{
                  sleepTotalFirstWeek.awakening / sleepTotalFirstWeek.totalDays
                }}</strong></span
              >
              <span
                >Previous Week:
                <strong *ngIf="sleepTotalLastWeek.totalDays > 0">{{
                  sleepTotalLastWeek.awakening / sleepTotalLastWeek.totalDays
                }}</strong></span
              >
            </div>
          </div>
        </div>
        <h3 class="text-center">Trend Graph</h3>

        <app-weekly-report-chart-sleep
          *ngIf="allWeeksSleepWellData.length > 0"
          [weeksData]="allWeeksSleepWellData"
        ></app-weekly-report-chart-sleep>
      </div>

      <!-- Feel Well -->
      <div class="weekly-report-page" *ngIf="pageId == 'feelWell'">
        <h2 class="weekly-report-page-title">
          <span class="icon-wrap"
            ><fa-icon
              [icon]="['fas', 'face-smile-relaxed']"
              [fixedWidth]="true"
            ></fa-icon
          ></span>
          Feel Well
        </h2>

        <div
          class="weekly-report-text mt-2 mb-3"
          *ngIf="+feelTotal.totalDays > 0"
        >
          <p>
            Well done for recording your Feel well progress and taking note of
            your mood, stress and worry levels while preparing for surgery.
            Prioritising your psychological wellbeing will really help to
            prepare you for surgery and to Sleep Well, Eat Well and Move Well
            too!
          </p>

          <p>
            It's normal for our mood, stress and worry levels to change
            throughout the day. The important thing is how we manage these
            changes and whether we feel well in ourselves
          </p>

          <p>
            Being mindful of how we feel in ourselves can help us identify
            patterns and make changes where needed.
          </p>

          <p>
            When looking at your weekly Feel Well report, try to think about:
          </p>
          <ul>
            <li>How you feel your mood has been this week overall?</li>
            <li>
              How have your worry or stress levels been this week overall?
            </li>
          </ul>

          <p>Since starting the iPrepwell programme</p>
          <ul>
            <li>
              have you noticed any changes in your mood, stress or worry levels?
            </li>
            <li>
              Is there anything you would like to change to improve your mood,
              stress or worry levels?
            </li>
          </ul>
        </div>
        <div
          *ngIf="+feelTotal.totalDays == 0"
          class="weekly-report-text mt-2 mb-3"
        >
          <p>
            You didn't record any Feel Well data this week. Don't worry and try
            to record it next week.
          </p>
        </div>
        <h3 class="text-center">Weekly Performance</h3>

        <div class="weekly-report-stats mb-4">
          <div class="weekly-report-stat">
            <div class="weekly-report-stat-title">Overall Feel Score</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                feelTotal.average
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong>{{ feelTotalFirstWeek.average }}</strong></span
              >
              <span
                >Previous Week:
                <strong>{{ feelTotalLastWeek.average }}</strong></span
              >
            </div>
          </div>

          <div class="weekly-report-stat" *ngIf="feelTotal.totalDays > 0">
            <div class="weekly-report-stat-title">Mood</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                feelTotal.mood / feelTotal.totalDays
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong *ngIf="feelTotalFirstWeek.totalDays > 0">{{
                  feelTotalFirstWeek.mood / feelTotalFirstWeek.totalDays
                }}</strong></span
              >
              <span
                >Previous Week:
                <strong *ngIf="feelTotalLastWeek.totalDays > 0">{{
                  feelTotalLastWeek.mood / feelTotalLastWeek.totalDays
                }}</strong></span
              >
            </div>
          </div>

          <div class="weekly-report-stat" *ngIf="feelTotal.totalDays > 0">
            <div class="weekly-report-stat-title">Worry</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                feelTotal.worry / feelTotal.totalDays
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong *ngIf="feelTotalFirstWeek.totalDays > 0">{{
                  feelTotalFirstWeek.worry / feelTotalFirstWeek.totalDays
                }}</strong></span
              >
              <span
                >Previous Week:
                <strong *ngIf="feelTotalLastWeek.totalDays > 0">{{
                  feelTotalLastWeek.worry / feelTotalLastWeek.totalDays
                }}</strong></span
              >
            </div>
          </div>

          <div class="weekly-report-stat" *ngIf="feelTotal.totalDays > 0">
            <div class="weekly-report-stat-title">Stress</div>
            <div class="weekly-report-stat-info">
              <span class="weekly-report-stat-info-value">{{
                feelTotal.stress / feelTotal.totalDays
              }}</span>
            </div>
            <div class="weekly-report-stat-footer">
              <span
                >1st Week:
                <strong *ngIf="feelTotalFirstWeek.totalDays > 0">{{
                  feelTotalFirstWeek.stress / feelTotalFirstWeek.totalDays
                }}</strong></span
              >
              <span
                >Previous Week:
                <strong *ngIf="feelTotalLastWeek.totalDays > 0">{{
                  feelTotalLastWeek.stress / feelTotalLastWeek.totalDays
                }}</strong></span
              >
            </div>
          </div>
        </div>
        <h3 class="text-center">Trend Graph</h3>

        <app-weekly-report-chart-feel
          *ngIf="allWeeksFeelWellData.length > 0"
          [weeksData]="allWeeksFeelWellData"
        ></app-weekly-report-chart-feel>
      </div>
    </ng-container>

    <ng-container *ngIf="!weekNo"> No week has been selected </ng-container>
  </div>
</div>
